// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3vhfh","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__jMN8e"};